import { fromJS, List } from 'immutable';
import { SET_ROOMS, UPDATE_ROOMS } from '../constants/rooms';

const initialState = List();

export default function roomsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ROOMS: {
      return fromJS(action.payload);
    }
    case SET_ROOMS: {
      return fromJS(action.payload);
    }
    default:
      return state;
  }
}
